import { z } from 'zod';
import { SyncableEntitySchema } from './entity';

export const SessionTypeSchema = z.enum(['FOCUS', 'DRILL', 'REVISION']);
export type SessionType = z.infer<typeof SessionTypeSchema>;

export const StudySessionSchema = SyncableEntitySchema.extend({
  subjectId: z.string().uuid(),
  topicId: z.string().uuid().nullable().default(null),
  startTime: z.string().datetime(),
  endTime: z.string().datetime(),
  durationSeconds: z.number().int().nonnegative(),
  pauseDurationSeconds: z.number().int().nonnegative().default(0),
  sessionType: SessionTypeSchema.default('FOCUS'),
  notes: z.string().default(''),
});

export type StudySession = z.infer<typeof StudySessionSchema>;

export const TimerStatusSchema = z.enum(['IDLE', 'RUNNING', 'PAUSED', 'COMPLETED']);
export type TimerStatus = z.infer<typeof TimerStatusSchema>;

export interface ActiveTimerSnapshot {
  status: TimerStatus;
  timerMode?: 'FOCUS' | 'BREAK';
  subjectId: string | null;
  topicId: string | null;
  targetSeconds: number;
  lastFocusDurationSeconds?: number;
  breakDurationSeconds?: number;
  startedAtTimestamp: number | null; // Wall clock ms
  pausedAtTimestamp: number | null;
  accumulatedPauseMs: number;
  sessionType: SessionType;
}
